export default __webpack_public_path__ + "static/media/LEDStrip.a020a601.png";